var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    transform: "matrix(1, 0, 0, 1, 0, 0)rotate(-45)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  .st0{fill:#000000;}  "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.291,156.616c-14.203,14.203-21.125,44.859-6.453,78.781c15.563,36,6.875,52.516-5.672,66.422 C138.181,315.084,36.009,403.381,15.791,423.601c-20.219,20.219-20.219,53.016,0,73.234s53,20.219,73.219,0 s107.719-119.75,121.781-134.375c12.984-13.531,30.422-21.25,66.438-5.672c33.906,14.656,64.578,7.75,78.766-6.469l19.375-19.359 L181.65,137.241L162.291,156.616z M65.994,473.819c-7.5,7.5-19.688,7.5-27.203,0c-7.5-7.516-7.5-19.688,0-27.203 c7.516-7.516,19.703-7.516,27.203,0C73.509,454.132,73.509,466.304,65.994,473.819z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M498.119,151.506l-85.063-85.063c-1.063-1.078-2.688-1.328-4.031-0.641l-37.422,19.406 c-1.328,0.703-2.953,0.438-4.016-0.625c-1.078-1.063-1.328-2.688-0.641-4.016l19.406-37.422c0.703-1.344,0.438-2.969-0.625-4.047 l-25.859-25.859c-9.219-9.203-21.938-14-34.938-13.141c-11.016,0.719-21.313,5.438-29.016,13.141 c-1.391,1.391-2.688,2.859-3.906,4.438l0,0l-88.688,115.5l174.859,174.875l115.516-88.703c1.563-1.203,3.047-2.5,4.422-3.891 c7.719-7.719,12.438-18,13.156-29.031C512.135,173.444,507.338,160.725,498.119,151.506z M380.4,274.1L237.275,130.959 l35.266-45.922c25.531,4.859,85,24.75,103.609,76.219c14.5,40.109,33.531,66.625,54.625,74.172L380.4,274.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/brush.432dcd0dd05b226337f7795478057801.svg";
export { ForwardRef as ReactComponent };